import FavIconBelgium from "@assets/favicons/favicon-bf-be.png";
import Paper from "@assets/icons/paper.svg";
import instagramIcon from "@assets/icons/new-instagram.svg";
import facebookIcon from "@assets/icons/new-facebook.svg";
import mailIcon from "@assets/icons/new-mail.svg";
import bfBeLogo from "@assets/logos/bf-be.svg";
import CheckmarkIcon from "@assets/icons/usp-check-mark.svg";

import { IPlatformSpecificInfo } from "../platform";

export const belgiumFRPlatform: IPlatformSpecificInfo = {
  id: 3,
  currency: "EUR",
  name: "Black Friday Expert",
  abbreviation: "be-fr",
  country: "Belgique",
  domain: "blackfridayexpert.be",
  merchantOverviewLink: "/magasins/",
  dealOverviewLink: "/offres/",
  urlAddition: "fr",
  isLandingPage: false,
  defaultBackButtonText: "Retourner",
  breadcrumbHomeName: "Accueil",
  breadcrumbHomeUrl: "/fr/",
  readingTimeText: {
    singular: "minute de lecture",
    plural: "minutes de lecture"
  },
  newsletterButtonTitle: "Inscrivez-vous!",
  newsletterModalTitle: "Inscrivez-vous à la newsletter",
  fallBackHeaderImage: "https://media.blackfridaynederland.nl/wordpress/20200430114412/default-blog-image-be.jpg",
  bottomFooter: {
    items: [
      {
        title: "Contacter",
        url: "/fr/contacter/"
      },
      {
        title: "Privacy",
        url: "/fr/privacy/"
      },
      {
        title: "Cookies",
        url: "/fr/cookies/"
      },
      {
        title: "Sitemap",
        url: "/sitemap/"
      }
    ],
    logo: {
      src: bfBeLogo,
      alt: "Logo Black Friday Expert",
      title: "Logo Black Friday Expert"
    },
    logoLink: "/fr/"
  },
  middleFooter: {
    links: [
      {
        id: "TRENDING_BLOCK",
        title: "Tout sur le Black Friday",
        links: []
      },
      {
        id: "SHOPS_BLOCK",
        title: "Boutiques les plus vues",
        links: []
      },
      {
        id: "THIRD_BLOCK",
        title: "Offres Black Friday",
        links: []
      }
    ],
    newsletter: {
      title: "Meld je aan voor de nieuwsbrief",
      text: "En ontvang de allerbeste deals",
      buttonText: "Newsletter",
      buttonIcon: Paper
    },
    googleReviews: {
      link: {
        url: "https://www.feedbackcompany.com/nl-nl/reviews/black-friday-expert",
        title: "Feedback Company Reviews"
      },
      rating: 5
    },
    socialMedia: {
      id: "SOCIAL_BLOCK",
      title: "Entrer en contact",
      socialItem: [
        {
          image: {
            src: facebookIcon,
            alt: "Facebook Icon",
            title: "Facebook Icon"
          },
          link: "https://www.facebook.com/BlackFridayNederland/"
        },
        {
          image: {
            src: instagramIcon,
            alt: "Instagram Icon",
            title: "Instagram Icon"
          },
          link: "https://www.instagram.com/blackfridaynl/"
        },
        {
          link: "mailto:info@blackfridaynederland.nl",
          image: {
            src: mailIcon,
            alt: "Mail Icon",
            title: "Mail Icon"
          }
        }
      ]
    }
  },
  fallbackMerchantHeader: {
    src: "https://media.blackfridaynederland.nl/wordpress/sites/3/20200424102322/Black-Friday-Magasins.jpg",
    alt: "Page de magasins",
    title: "Header page de magasins"
  },
  logo: {
    src: bfBeLogo,
    alt: "Black Friday Logo",
    title: "Black Friday Logo"
  },
  uspModule: {
    uniqueSellingPoints: [
      {
        icon: CheckmarkIcon,
        link: {
          url: "/fr/magasins/",
          title: "Toutes les offres en un seul coup d'œil"
        }
      },
      {
        icon: CheckmarkIcon,
        link: {
          url: "/fr/offres/",
          title: "Obtenez les meilleures offres !"
        }
      },
      {
        icon: CheckmarkIcon,
        link: {
          url: "/fr/black-friday/",
          title: "Ne manquez rien du Black Friday"
        }
      }
    ]
  },
  storeTabs: [
    {
      href: "/magasins/",
      title: "Magasins",
      isSelected: true
    },
    {
      href: "/offres/",
      title: "Offres"
    }
  ],
  dealTabs: [
    {
      href: "/magasins/",
      title: "Magasins"
    },
    {
      href: "/offres/",
      isSelected: true,
      title: "Offres"
    }
  ],
  locale: "fr-BE",
  tagManagerScriptLocation: "/static/googletagmanager-fr-be.js",
  favIcon: FavIconBelgium,
  favIconPublic: "https://media.blackfridaynederland.nl/static/FavIcons/favicon-bf-expert-be.png",
  gtm: "GTM-5JMPWC4",
  enableDealAlerts: false,
  isOffline: false
};
